import "core-js/modules/es6.function.name.js";
import "core-js/modules/es6.string.starts-with.js";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import jwtDecode from 'jwt-decode';
import { refreshTokenIfNecessary } from '~/helpers/auth-helpers';
import { decodedToken } from '~/helpers/connection-helper';
import { newRelicCall } from '~/helpers/log-helper';
import logout from '~/helpers/logout-helper';
export default (function (_ref) {
  var app = _ref.app,
    store = _ref.store;
  app.router.beforeEach( /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
      var tokenDecoded, iatTokenMilliseconds, sellerToken;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!to.name.startsWith('market-language-user')) {
              _context.next = 14;
              break;
            }
            _context.prev = 1;
            tokenDecoded = decodedToken();
            iatTokenMilliseconds = tokenDecoded.iat * 1000; // entre 04/07/2022 00:01 et 06/07/2022 15:00
            // 15h 1657112400000
            // 18h 1657123200000
            if (!(tokenDecoded.firstname && iatTokenMilliseconds > 1656885660000 && iatTokenMilliseconds < 1657112400000)) {
              _context.next = 10;
              break;
            }
            newRelicCall({
              msg: 'force logout 0607',
              level: 'warn',
              customFilter: 'force-logout'
            });
            _context.next = 8;
            return logout(store);
          case 8:
            next({
              path: "/".concat(to.params.market, "/").concat(to.params.language, "/login"),
              query: {
                redirectUrl: to.fullPath
              }
            });
            return _context.abrupt("return");
          case 10:
            _context.next = 14;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](1);
          case 14:
            if (!from.name) {
              _context.next = 17;
              break;
            }
            _context.next = 17;
            return refreshTokenIfNecessary({
              app: app,
              store: store
            });
          case 17:
            sellerToken = app.$cookies.get('MDM_SELLER_TOKEN');
            if (sellerToken) store.dispatch('seller/setSeller', jwtDecode(sellerToken));
            store.dispatch('routeNavigation/updateCurrentRoute', to);
            store.dispatch('routeNavigation/updatePreviousRoute', from);
            next();
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 12]]);
    }));
    return function (_x, _x2, _x3) {
      return _ref2.apply(this, arguments);
    };
  }());
});